import React, {Component} from "react"
import PropTypes from "prop-types"
import {Card} from "semantic-ui-react"
import queryString from "qs"
import {withRouter} from "react-router-dom"
import Filter from "components/Filter/Filter"
import Breadcrumbs from "components/Breadcrumbs/Breadcrumbs"
import ProductCard from "components/Product/ProductCard"

import shop from "shop/shop"

@withRouter
export default class CollectionExtraPage extends Component {
  constructor(props) {
    super()
    let query = queryString.parse( props.location.search, { ignoreQueryPrefix: true })

    this.state = {
      products: [],
      loaded:   false,
      filter:   {
        total:       shop.config.pageSize,
        pageSize:    shop.config.pageSize,
        currentPage: 1,
      },
      query:    {
        page:   query.page || 1,
        count:  query.count || shop.config.pageSize,
        total:  48,
        filter: null,
        limit:  3,
        id:     null
      }
    }
  }

  componentDidMount() {
    this.loadFrom( this.props )
  }

  loadFrom(props) {
    let query   = queryString.parse( this.props.location.search )
    query.count = query.count || this.state.query.count
    query.page  = query.page || 1
    this.load( query )
  }

  load(query) {
    let filter   = new shop.Filter()
    query.filter = filter
      .searchField( true )
      .field( this.props.match.params.extra )
      .query( this.props.match.params.extraValue )

    shop.products.search( "%%", query )
      .then( res => {
        this.setState( {
          size:     res.size,
          products: res.products,
        } )
      } )
  }

  onChangeFilter = (filter) => {
    this.updateQuery( filter )
  }

  updateQuery(filter) {
    console.log( `updateQuery`, filter )
    let { page, sort, pageSize, id } = filter
    // console.log(`change`, {
    //    page,
    //    sort,
    //    pageSize,
    //    id
    // })
    id          = id || this.id
    let query   = queryString.parse( this.props.location.search )
    query.page  = page || query.page
    query.count = pageSize || query.count
    query.sort  = sort || query.sort
    query.id    = id || query.id
    console.log( `change`, query )

    let strQuery = queryString.stringify( query )
    this.props.history.replace( `${this.props.location.pathname}?${strQuery}` )
    this.load( query )
    this.setState( { query } )
  }

  render() {
    let filter = {
      currentPage: Number( this.state.query.page ),
      total:       Number( this.state.size ),
      pageSize:    Number( this.state.query.count || shop.config.pageSize ),
      id:          String( this.state.query.id ),
      sort:        String( this.state.query.sort )
    }

    console.log( `currentPage`, filter.currentPage )

    let path = []

    path.push( {
      title: "Home",
      link:  `/`
    } )

    path.push( {
      title: `${this.props.match.params.extra} – ${this.props.match.params.extraValue}`,
      link:  `/collection-extra/${this.props.match.params.extra}/${this.props.match.params.extraValue}`
    } )

    console.log( `filter`, { filter } )

    return (
      <div className="container ">
        <Breadcrumbs path={path}/>
        {/*<Col sm="1/5">*/}
        {/*<NavigationSidebar> </NavigationSidebar>*/}
        {/*</Col>*/}
        {/*Filter*/}
        <section style={{ marginBottom: "0" }}>
          <Filter onChange={this.onChangeFilter} {...filter} />
        </section>
        {/*Products from Category*/}
        <section>
          <Card.Group itemsPerRow={4} stackable>
            {this.state.products.map( (product, key) => {
              return <ProductCard key={key}
                                  product={product}> </ProductCard>
            } )}
          </Card.Group>
        </section>
        {/*Filter*/}
        <section className="pv4">
          <Filter showFilter={true}
                  onChange={this.onChangeFilter} {...filter} />
        </section>
      </div>
    )
  }
}

CollectionExtraPage.propTypes = {
  params:   PropTypes.object,
  filter:   PropTypes.object,
  location: PropTypes.object
}




// WEBPACK FOOTER //
// ./src/pages/CollectionExtraPage.js